import { styled } from "stitches";

export const AudioVisualizerWrapper = styled("canvas", {
  position: "absolute",
  width: "100%",
  height: "100%",
});
